module.exports = __webpack_public_path__ + "static/media/bill_of_lading_icon_quick_books.14f76d2b.svg";